export const actions = {
  ACTIVE: "active"
};

export const mutations = {
  SET_SUCCESS: "setSuccess",
  SET_LOADING: "setLoading"
};
